import { useState, useEffect } from 'react';

const useSpeechRecognition = () => {
  const [isSupported, setIsSupported] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
      return;
    }

    // Check for Web Speech API support
    if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
      setError('Speech recognition is not supported in your browser. Try using Chrome, Edge, or Safari.');
      setIsSupported(false);
      return;
    }

    // Check for microphone permission
    const checkMicrophonePermission = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true });
        setIsSupported(true);
      } catch (err) {
        if (err.name === 'NotAllowedError') {
          setError('Microphone access was denied. Please allow microphone access to use voice commands.');
        } else if (err.name === 'NotFoundError') {
          setError('No microphone found. Please ensure you have a working microphone.');
        } else {
          setError(`Error accessing microphone: ${err.message}`);
        }
        setIsSupported(false);
      }
    };

    checkMicrophonePermission();
  }, []);

  return { isSupported, error };
};

export default useSpeechRecognition;
